import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr';
import { i18n } from '../../translate/i18n';
import axios from 'axios';
let CancelToken = axios.CancelToken;
let fetchSites_cancel;
let checkDeleteSites_cancel;
let fetchSitesByTenant_cancel;
let fetchAllSitesByTenant_cancel;

export const fetchSitesSuccess = (sites) => {
  return {
    type: actionTypes.FETCH_SITES_SUCCESS,
    sites: sites
  };
};

export const fetchAllSitesSuccess = (sites) => {
    return {
      type: actionTypes.FETCH_ALL_SITES_SUCCESS,
      sites: sites
    };
  };

export const requestSitesFail = (error) => {
  return {
    type: actionTypes.REQUEST_SITES_FAIL,
    error: error
  };
};

export const requestSitesStart = () => {
  return {
    type: actionTypes.REQUEST_SITES_START
  };
};

export const deleteSitesSuccess = (site) => {
  return {
    type: actionTypes.DELETE_SITES_SUCCESS,
    site: site
  }
}

export const checkDeleteSitesSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_SITES_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateSitesSuccess = (site) => {
  return {
    type: actionTypes.UPDATE_SITES_SUCCESS,
    site: site
  }
}

export const postSitesSuccess = (site) => {
  return {
    type: actionTypes.POST_SITES_SUCCESS,
    site: site
  }
}

export const selectSitePlaces = (site) => {
  return {
    type: actionTypes.SELECT_SITE_PLACES,
    site
  }
}

export const setSelectedSites = (sites) => {
  return {
    type: actionTypes.SET_SELECTED_SITES,
    sites
  }
}

export const deleteFilteredSite = (site) => {
  return {
    type: actionTypes.FILTER_SITES_REMOVE,
    site
  }
}

export const filterSitesRemove = (site) => {
  return {
    type: actionTypes.SELECT_SITE_PLACES,
    site
  }
}

export const setSitePlaces = (site) => {
  return {
    type: actionTypes.SET_SITE_PLACES,
    site
  }
}

export const selectSiteQuestions = (site) => {
    return {
      type: actionTypes.SELECT_SITE_QUESTIONS,
      site
    }
  }

export const defaultSiteSelectedPlaces = (user) => {
    return {
        type: actionTypes.SELECT_DEFAULT_PLACES,
        user
    }
}

export const defaultSiteSelectedQuestions = (user) => {
    return {
        type: actionTypes.SELECT_DEFAULT_QUESTIONS,
        user
    }
}


export const fetchSites = (page, limit, search, order, orderBy) => {
  fetchSites_cancel && fetchSites_cancel();
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestSitesStart());
      const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
      API.get('/sites' + queryParams, {
        cancelToken: new CancelToken(function executor(c) {
          fetchSites_cancel = c;
        })
      })
        .then(res => {
          dispatch(fetchSitesSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestSitesFail(err));
          reject(err);
        });
    });
  }
};

export const fetchSitesByTenant = (tenantId, page, limit, search, order, orderBy) => {
  fetchSitesByTenant_cancel && fetchSitesByTenant_cancel();
  return dispatch => {
    dispatch(requestSitesStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('tenants/' + tenantId + '/sites' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchSitesByTenant_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchSitesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestSitesFail(err));
      });
  };
};


export const fetchAllSitesByTenant = (tenantId) => {
    fetchAllSitesByTenant_cancel && fetchAllSitesByTenant_cancel();
    return dispatch => {
      return new Promise((resolve, reject) => {
        dispatch(requestSitesStart());
        API.get('tenants/' + tenantId + '/allsites', {
          cancelToken: new CancelToken(function executor(c) {
            fetchAllSitesByTenant_cancel = c;
          })
        })
          .then(res => {
            dispatch(fetchAllSitesSuccess(res.data));
            resolve('success');
          })
          .catch(err => {
            dispatch(requestSitesFail(err));
            reject('error');
          });
      });
    };
  };

export const deleteSites = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestSitesStart());
      API.put('/sites/' + index + '/delete')
        .then(res => {
          dispatch(deleteSitesSuccess(res.data));
          toastr.success(i18n.t('deleteSites.toastr'), `${res.data.name}${i18n.t('deleteSites.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestSitesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const checkDeleteSites = (index) => {
  checkDeleteSites_cancel && checkDeleteSites_cancel()
  return dispatch => {
    dispatch(requestSitesStart());
    API.get('/sites/' + index + '/checkdelete', {
      cancelToken: new CancelToken(function executor(c) {
        checkDeleteSites_cancel = c;
      })
    })
      .then(res => {
        dispatch(checkDeleteSitesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestSitesFail(err));
      });
  }
}

export const postSites = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestSitesStart());
      const query = body.copyChecklist ? `?copiedSiteId=${body.copiedSiteId}` : '';
      API.post('/sites' + query, { name: body.name })
        .then(res => {
          dispatch(postSitesSuccess(res.data));
          toastr.success(i18n.t('postSites.toastr'), `${res.data.name}${i18n.t('postSites.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestSitesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('toastrError.toastrError'), i18n.t('toastrError.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const updateSites = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestSitesStart());
      API.put('/sites/' + index, body)
        .then(res => {
          dispatch(updateSitesSuccess(res.data));
          toastr.success(i18n.t('updateSites.toastr'), `${res.data.name}${i18n.t('updateSites.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestSitesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateSites.toastrError'), i18n.t('updateSites.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}
